class CartRecommendations extends HTMLElement {
  connectedCallback() {
    if (!('IntersectionObserver' in window)) {
      this.generateRecommendations();
      return;
    }
    this.visibilityObserver = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) {
        this.visibilityObserver.disconnect();
        this.generateRecommendations();
      }
    });
    this.visibilityObserver.observe(this.closest('sidebar-drawer') || this);
  }

  disconnectedCallback() {
    if (this.visibilityObserver) this.visibilityObserver.disconnect();
  }

  generateRecommendations() {
    const firstItem = document.querySelector('#AjaxCartForm [data-js-cart-item]');
    if (!firstItem) return Promise.resolve();
    const url = `${KROWN.settings.routes.product_recommendations_url}?section_id=${this.dataset.section}&product_id=${firstItem.dataset.productId}&limit=${this.dataset.limit}`;
    if (this.pendingUrl === url) return this.pendingRequest;
    this.pendingUrl = url;
    const request = fetch(url)
      .then(response => {
        if (!response.ok) throw new Error('Recommendation request failed');
        return response.text();
      })
      .then(text => {
        if (this.pendingRequest !== request || !this.isConnected) return;
        const content = new DOMParser().parseFromString(text, 'text/html')
          .querySelector('[data-js-cart-recommendations-performed]');
        if (content && content.querySelector('[data-js-product-item]')) {
          this.innerHTML = content.innerHTML;
        }
      })
      .catch(() => {})
      .finally(() => {
        if (this.pendingRequest === request) {
          this.pendingUrl = null;
          this.pendingRequest = null;
        }
      });
    this.pendingRequest = request;
    return request;
  }
}
customElements.define('cart-recommendations', CartRecommendations);
